import type { KeyboardEvent, MouseEvent, ReactElement, ReactNode, Ref } from 'react';

import { CARD_PADDING } from '@treneo/shared/themes';

import type { SxProps, Theme } from '@mui/material';
import { Card as MuiCard } from '@mui/material';

import { styled } from '../styled';

const StyledCard = styled(MuiCard)`
  padding: ${CARD_PADDING};
`;

export type CardProps = {
  children: ReactNode;
  className?: string;
  sx?: SxProps<Theme>;
  ref?: Ref<HTMLDivElement>;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  onKeyDown?: (event: KeyboardEvent<Element>) => void;
  tabIndex?: number;
  role?: string;
  'aria-label'?: string;
};

type CardPropsReadonly = Readonly<CardProps>;

export const Card = ({
  children,
  className,
  sx,
  ref: refProp,
  onClick,
  onKeyDown,
  tabIndex,
  role,
  'aria-label': ariaLabel
}: CardPropsReadonly): ReactElement => {
  return (
    <StyledCard
      variant='outlined'
      className={className}
      sx={sx}
      ref={refProp}
      onClick={onClick}
      onKeyDown={onKeyDown}
      tabIndex={tabIndex}
      role={role}
      aria-label={ariaLabel}
    >
      {children}
    </StyledCard>
  );
};
